import loginBanner from "./login_banner.jpg"
import admission from "./admission.jpg"
import examTimeTable from "./Timeforexams.jpg"
import examinationResult from "./results.jpg"
import classSubject  from "./subjectClass.jpg"
import monthlyFee from "./monthlyFee.png"
import admit from "./admit.jpeg"
import certificate from "./certificate.png"

export const ICONS = {
    login_banner: loginBanner,
    admission: admission,
    admit:admit,
    examTimeTable:examTimeTable,
    examinationResult:examinationResult,
    classSubject:classSubject,
    monthlyFee:monthlyFee,
    document:certificate
}